import dayjs from 'dayjs'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PageMainContentContainer } from '../MentorAvailabilityPage/MentorAvailabilityPageStyles'
import {
  BookingRequestStripForMentor,
  CloseButtonForBack,
  getFilteredTheBookingRequests,
} from './MentorBookingRequestComponents'
import {
  deleteBookingRequest,
  selectReceivedBookingRequests,
} from 'src/mentor/reducers/bookingRequest/bookingRequestReducer'
import { useNavigate } from 'react-router-dom'

export default function MentorBookingRequestActivePage() {
  const receivedBookingRequests = useSelector(selectReceivedBookingRequests)
  const [timeNow, setTimeNow] = useState(dayjs())
  const dispatch = useDispatch()

  useEffect(() => {
    const interval = setInterval(() => setTimeNow(dayjs()), 10000) // Run every 10 seconds
    return () => clearInterval(interval)
  }, [])

  const removeBookingRequestFromStoreById = (bookingReqId) => {
    dispatch(deleteBookingRequest(bookingReqId))
  }

  useEffect(() => {
    console.log({ receivedBookingRequests })
  }, [receivedBookingRequests])

  const navigate = useNavigate()

  return (
    <PageMainContentContainer style={{ marginTop: '100px', padding: '20px' }}>
      <div style={{ marginBottom: '32px' }}>
        <CloseButtonForBack />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>
          <b>Active Requests</b>
        </div>
      </div>
      <div>
        Can&apos;t find a request?{' '}
        <i>
          <u>
            <span
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/booking-requests-for-mentors/all')}
            >
              Click here
            </span>
          </u>
        </i>
      </div>
      <div style={{ marginBottom: '32px', cursor: 'pointer' }}>
        or{' '}
        <span onClick={() => navigate('/mentor-home/my-calendar?view=booked')}>
          <u>Check your existing bookings</u>
        </span>
      </div>
      <div style={{ position: 'relative', width: '100%', minHeight: '50px' }}>
        {getFilteredTheBookingRequests(receivedBookingRequests)?.length > 0 ? (
          getFilteredTheBookingRequests(receivedBookingRequests)?.map((item, index) => {
            if (timeNow.isBefore(dayjs.utc(item?.startTime, 'YYYY-MM-DD HH:mm:ss'))) {
              return (
                <BookingRequestStripForMentor
                  key={index}
                  data={item}
                  afterAcceptOrRejectFunc={() => removeBookingRequestFromStoreById(item?.id)}
                />
              )
            } else {
              return null
            }
          })
        ) : (
          <div>No new requests</div>
        )}
      </div>
    </PageMainContentContainer>
  )
}
